import {PonyExpress} from '@/matic/components/ui/PonyExpress';

/**
 * What a Quote Desk page shows while its chunk or first data is on the way: the rider
 * galloping on the page's own white, so arriving at the desk never flashes blank.
 * The Suspense fallback for every Quote Desk route (routes/config.tsx).
 */
export function QuoteDeskLoading() {
  return (
    <div
      role="status"
      aria-label="Loading the Quote Desk"
      className="flex h-full min-h-0 flex-1 items-center justify-center bg-white"
    >
      <PonyExpress size={140} />
    </div>
  );
}
